import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { sendSatisfy } from 'modules/actions/starScore';
import './style.scss';

const domainUrlParam = process.env.REACT_APP_DOMAIN_URL;

const ServiceGuide = () => {
  const dispatch = useDispatch();
  const closeServiceGuide = () => {
    dispatch(disableAllMenu());
    // setPayloadStatus({ score: 5, name: '매우만족', content: '', status: 'N' });
  };
  const [displayStatus, setDisplayStatus] = useState({ guide: true, auto: false });

  // // state
  // const [payloadStatus, setPayloadStatus] = useState({ score: 5, name: '매우만족', content: '' });
  // const StarName = ['매우불편', '불편', '보통', '만족', '매우만족'];

  // // event
  const changeDisplay1 = () => {
    setDisplayStatus({ guide: true, auto: false });
  };
  const changeDisplay2 = () => {
    setDisplayStatus({ guide: false, auto: true });
  };

  // const setContentValue = contentStr => {
  //   if (contentStr) {
  //     setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'Y' });
  //   } else {
  //     setPayloadStatus({ ...payloadStatus, content: contentStr, status: 'N' });
  //   }
  // };
  const tabRefs = useRef([]);
  useEffect(() => {
    if (tabRefs.current[0]) {
      tabRefs.current[0].focus();
    }
  }, []);
  const handleTabKeyDown = (e, tabIndex) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;

    e.preventDefault();
    const nextTabIndex = tabIndex === 0 ? 1 : 0;
    if (nextTabIndex === 0) changeDisplay1();
    else changeDisplay2();
    tabRefs.current[nextTabIndex].focus();
  };
  return (
    <div className="help_area">
      <div className="help_header">
        <span>이용 안내</span>
        <button
          className="ri-close-line"
          type="button"a
	  aria-label="이용 안내 닫기"
          onClick={closeServiceGuide}
        />
      </div>
      <div className="help_tab_area" role="tablist" aria-label="이용 안내 항목">
        <button
          type="button"
          className="help_tab"
          ref={element => { tabRefs.current[0] = element; }}
          role="tab"
          id="service-guide-tab"
          aria-selected={displayStatus.guide}
          aria-controls="service-guide-panel"
          tabIndex={displayStatus.guide ? 0 : -1}
          onClick={changeDisplay1}
          onKeyDown={e => handleTabKeyDown(e, 0)}
          style={{
            borderBottom: displayStatus.guide ? '2px #BE314B solid' : '',
            color: displayStatus.guide ? '#BE314B' : '',
            backgroundColor: displayStatus.guide ? '#FFFFFF' : '#F5F5F5',
          }}
        >
          챗봇 화면 안내
        </button>
        <button
          type="button"
          className="help_tab"
          ref={element => { tabRefs.current[1] = element; }}
          role="tab"
          id="auto-complete-tab"
          aria-selected={displayStatus.auto}
          aria-controls="auto-complete-panel"
          tabIndex={displayStatus.auto ? 0 : -1}
          onClick={changeDisplay2}
          onKeyDown={e => handleTabKeyDown(e, 1)}
          style={{
            borderBottom: displayStatus.auto ? '2px #BE314B solid' : '',
            color: displayStatus.auto ? '#BE314B' : '',
            backgroundColor: displayStatus.auto ? '#FFFFFF' : '#F5F5F5',
          }}
        >
          질문 자동 완성
        </button>
      </div>
      <div className="help_content">
        <div id="service-guide-panel" role="tabpanel" aria-labelledby="service-guide-tab" hidden={!displayStatus.guide}>
          <img
            src={`/${domainUrlParam}/ibricks/images/help_03.png`}
            alt="왼쪽 상단 대화 설정 버튼으로 폰트 크기설정 작게 보통 크게 자동 완성 설정 켜기 끄기 조절 가능. 오른쪽 퀵메뉴 버튼으로 처음으로 이용안내 대화가이드 서비스 만족도 평가 가능. 왼쪽 아래 버튼은 홈버튼으로 분야별 안내 담당 안내 행정기관 위치 처음으로 민원발급기 위치 민원접수 자주하는 질문 도움말 기능 가능. 화면 가장 아래 입력창은 대화 입력창"
            className="img_help"
          />
        </div>
        <div id="auto-complete-panel" role="tabpanel" aria-labelledby="auto-complete-tab" hidden={!displayStatus.auto}>
          <img
            src={`/${domainUrlParam}/ibricks/images/help_04.png`}
            alt="질문 자동 완성 이미지 입력한 키워드가 포함된 질문이 자동으로 추천됩니다. 예방접종 입력시 예방접종 증명서 발급 안내, 예방접종 주의사항, 영유아 예방접종 안내 표시"
            className="img_help"
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceGuide;
